import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const httpOptions = {
    headers: new HttpHeaders({ 'Accept': 'application/json' })
};


@Injectable({ providedIn: 'root' })
export class BaseService {


    constructor(protected http: HttpClient) {
    }


    static materialBuster = new Subject<void>();


    public queue = [];


    public get<T>(url: string, requestBody?: any, responseType?: any): Observable<T> {
        return this.http.get<T>(url, { headers: httpOptions.headers, params: requestBody, responseType: responseType }).pipe(
            catchError((error) => this.handleError(error, url))// then handle the error
        );
    }

    public post<T>(url: string, requestBody?: any, responseType?: any): Observable<T> {
        return this.http.post<T>(url, requestBody, { headers: httpOptions.headers, responseType: responseType }).pipe(
            catchError((error) => this.handleError(error, url))// then handle the error
        );
    }

    public put<T>(url: string, requestBody: any): Observable<T> {
        return this.http.put<T>(url, requestBody, { headers: httpOptions.headers }).pipe(
            catchError((error) => this.handleError(error, url))// then handle the error
        );
    }

    public delete<T>(url: string, requestBody?: any, responseType?: any): Observable<T> {
        return this.http.delete<T>(url, { headers: httpOptions.headers, params: requestBody, responseType: responseType });
    }

    protected handleError(error: HttpErrorResponse | Error, url = ''): Observable<any> {
        // v2 only: return BE error/message so KYC (and other v2 callers) can toast it.
        if (url.includes('/v2/')) {
            const message = this.resolveV2ErrorMessage(error);
            return throwError(() => new Error(message));
        }

        if (error instanceof HttpErrorResponse) {
            if (error.error instanceof Error) {
                // A client-side or network error occurred. Handle it accordingly.
                console.error('An error occurred:', error.error.message);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                // console.log(JSON.stringify(error));
                console.error(`Status code ${error.status}, with error: ${JSON.stringify(error?.error?.error ?? error?.error ?? error)}`);
            }
        } else {
            console.error('An error occurred:', error.message);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }

    /** Prefer BE JSON `error` / `message`; never toast raw HTML error pages. */
    private resolveV2ErrorMessage(error: HttpErrorResponse | Error): string {
        if (error instanceof HttpErrorResponse) {
            const fromBody = this.readErrorBody(error.error,error.status,error.statusText);
            if (fromBody) return fromBody;
            if (error.status && error.statusText) {
                return `${error.status} ${error.statusText}`;
            }
            if (error.message?.trim()) {
                return error.message.trim();
            }
        }
        if (error instanceof Error && error.message?.trim()) {
            return error.message.trim();
        }
        return 'Something bad happened; please try again later.';
    }

    private readErrorBody(body: unknown,status?: number,statusText?: string): string {
        if(status && statusText && status ===404 && statusText.includes('Not Found')){
            return 'The requested resource was not found.';
        }
        if (typeof body === 'string' && body.trim()) {
                return body.trim();
        }
        if (body && typeof body === 'object') {
            const record = body as { error?: unknown; message?: unknown };
            const nested = record.error;
            if (typeof nested === 'string' && nested.trim()) return nested.trim();
            if (nested && typeof nested === 'object') {
                const nestedRecord = nested as { error?: unknown; message?: unknown };
                const nestedMsg = nestedRecord.error ?? nestedRecord.message;
                if (typeof nestedMsg === 'string' && nestedMsg.trim()) return nestedMsg.trim();
            }
            if (typeof record.message === 'string' && record.message.trim()) {
                return record.message.trim();
            }
        }
        return '';
    }

}
